package net.frozenbit.games.soundgame.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.Font
import soundgame.app.shared.generated.resources.Res
import soundgame.app.shared.generated.resources.audiowide_regular
import soundgame.app.shared.generated.resources.courier_prime_regular
import soundgame.app.shared.generated.resources.finger_paint_regular

val monospace = FontFamily.Monospace

object Typography {
    object Host {
        val titleSize = 64.sp
        val bodySize = 36.sp

        val title = TextStyle(
            fontSize = titleSize,
        )

        val body = TextStyle(
            fontSize = bodySize,
        )

        val small = TextStyle(
            fontSize = 24.sp,
        )
    }

    object Controller {
        val title = 28.sp
        val body = 20.sp
    }

    @Composable
    fun fingerPaint() = FontFamily(
        Font(Res.font.finger_paint_regular),
    )

    @Composable
    fun audiowide() = FontFamily(
        Font(Res.font.audiowide_regular),
    )

    @Composable
    fun courierPrime() = FontFamily(
        Font(Res.font.courier_prime_regular),
    )
}